import { IconPlayerPlay } from '@tabler/icons-react';
import { ActionIcon } from '@mantine/core';

const PlayButton = () => {
  return (
    <ActionIcon
      size="lg"
      variant="light"
      color="green"
      radius="xl"
      style={{
        flexShrink: 0,
        marginRight: '12px',
      }}
    >
      <IconPlayerPlay size="1rem" />
    </ActionIcon>
  );
};

export default PlayButton; 